import { render } from "./NoAccount.vue?vue&type=template&id=63f4866c"
import script from "./NoAccount.vue?vue&type=script&lang=js"
export * from "./NoAccount.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__